// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons___049T","alertIcon":"ConfirmModal_alertIcon__2Wlwi"};